<template>
    <Tooltip :is-teleported="true" :is-disabled="!isTruncated" class="max-w-full">
        <template #trigger="tooltipProps">
            <span
                class="flex max-w-full flex-row items-center gap-2 rounded-xs text-sm text-gray-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700"
                :class="{ 'cursor-help': isTruncated }"
                :aria-describedby="isTruncated ? tooltipProps['aria-labelledby'] : undefined"
                :tabindex="isTruncated ? 0 : undefined"
            >
                <UserReferenceAvatars :users="props.assignedUsers" :mode="props.mode" />
                <span ref="namesElement" class="truncate">{{ namesText }}</span>
            </span>
        </template>

        <template #text>
            <span class="block max-w-md">{{ namesText }}</span>
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import { useElementOverflow } from '@vueuse/core';
import { computed, useTemplateRef } from 'vue';
import Tooltip from '../Tooltip/Tooltip.vue';
import UserReferenceAvatars from './UserReferenceAvatars.vue';

export type UserReferenceMode = 'Max-1' | 'Multiple';

type AssignedUser = {
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl?: string;
};

type UserReferenceStaticProps = {
    mode: UserReferenceMode;
    assignedUsers: AssignedUser[];
};

const props = defineProps<UserReferenceStaticProps>();

const namesText = computed(() =>
    props.assignedUsers.length === 0
        ? '-'
        : props.assignedUsers.map((user) => `${user.firstName} ${user.lastName}`).join(', '),
);

const namesElement = useTemplateRef('namesElement');
const { isXOverflowed: isTruncated } = useElementOverflow(namesElement, { observeMutation: true });
</script>
